var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-box" },
    [
      _c(
        "div",
        { staticClass: "tree-title" },
        [
          _c(
            "el-dropdown",
            {
              attrs: { placement: "bottom" },
              on: { command: _vm.handleCommand },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "dropdownbutton",
                  attrs: { type: "primary", size: "small" },
                },
                [_c("i", { staticClass: "el-icon-plus" }), _vm._v(" 新 建 ")]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    { attrs: { command: "note", icon: "el-icon-circle-plus" } },
                    [_vm._v("新建笔记")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: {
                        command: "folder",
                        icon: "iconfont iconjishiben-xinjianwenjianjia1",
                      },
                    },
                    [_vm._v("新建文件夹")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "recently",
              class: _vm.recentlyShow ? "activeColor" : "",
              on: { click: _vm.onRecently },
            },
            [
              _c("span", { staticClass: "iconfont iconshijian" }),
              _c("span", [_vm._v("最近使用")]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { directives: [{ name: "height", rawName: "v-height" }] },
        [
          _c(
            "el-scrollbar",
            { staticStyle: { height: "100%" } },
            [
              _c(
                "div",
                {
                  staticClass: "main-box",
                  class: _vm.focusShow ? "focus" : "",
                  attrs: { tabindex: "1" },
                  on: {
                    click: function ($event) {
                      return _vm.handleClick(1)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "iconfont iconwenjianjia1" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("我的文件夹")]),
                ]
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  data: _vm.treeData,
                  props: _vm.defaultProps,
                  "highlight-current": true,
                  "default-expand-all": true,
                  "expand-on-click-node": false,
                  "current-node-key": "id",
                  "node-key": "id",
                  indent: 10,
                },
                on: { "node-click": _vm.handleClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c(
                        "div",
                        { staticClass: "custom-tree" },
                        [
                          _c(
                            "div",
                            { staticClass: "custom-tree-node" },
                            [
                              data.name.length > 11
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        content: data.name,
                                        placement: "top",
                                        trigger: "hover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex-box",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "tree-icon icon iconfont iconwenjianjia color-file",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "over-text flex-box-title",
                                            },
                                            [_vm._v(_vm._s(data.name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "flex-box-title" },
                                            [
                                              _vm._v(
                                                "(" + _vm._s(data.count) + ")"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c("div", { staticClass: "flex-box" }, [
                                    _c("i", {
                                      staticClass:
                                        "tree-icon icon iconfont iconwenjianjia color-file",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "over-text flex-box-title",
                                      },
                                      [_vm._v(_vm._s(data.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "flex-box-title" },
                                      [_vm._v("(" + _vm._s(data.count) + ")")]
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-popover",
                            {
                              ref: "pop-" + data.id,
                              attrs: {
                                placement: "bottom-end",
                                trigger: "click",
                                offset: 10,
                              },
                              on: {
                                "after-enter": function ($event) {
                                  return _vm.handleShow(data.id)
                                },
                                hide: _vm.handleHide,
                              },
                            },
                            [
                              _c("div", { staticClass: "right-item-list" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "right-item",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.addCate(1, data)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("calendar.addtype")))]
                                ),
                                _vm._v(" "),
                                data.id != ""
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "right-item",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.addEdit(data)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("public.edit")))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                data.id != ""
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "right-item",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleDelete(data)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("public.delete")) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "icon iconfont icongengduo right-icon ml10",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("dialogForm", {
        ref: "dialogForm",
        attrs: {
          "roles-config": _vm.rolesConfig,
          "form-data": _vm.formBoxConfig,
        },
        on: {
          isOk: function ($event) {
            return _vm.menuList()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }